// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from '@/utils';
import moment from 'moment';

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 *
 * @param {*} val
 * @returns
 */
export function phoneFilter(val) {
  if (val) {
    const reg = /^(.{3}).*(.{4})$/;
    return val.replace(reg, '$1****$2');
  }
}

function parseDateString(input) {
  // 定义正则表达式来匹配不同的日期时间格式
  const regexFull = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/;
  const regexWithSeconds = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})$/;
  const regexWithMinutes = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2})$/;
  const regexDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/;

  // 尝试匹配不同的格式
  if (regexFull.test(input)) {
      // 年-月-日 时-分-秒
      return `DD/MM/YYYY HH:mm`;
  } else if (regexWithSeconds.test(input)) {
      // 年-月-日 时-分
      return `DD/MM/YYYY HH:mm`;
  } else if (regexWithMinutes.test(input)) {
      // 年-月-日 时
      return `DD/MM/YYYY HH`;
  } else if (regexDateOnly.test(input)) {
      // 年-月-日
      return `DD/MM/YYYY`;
  } else {
      // 格式不正确
      return false;
  }
}

export function timeFilters(date, options = { isSession: false, dateFormat: '' }) {
  const regex = /^\d{4}-\d{2}-\d{2}/;
  if (date && !isNaN(new Date(date).getTime()) && regex.test(date)) {
    if (options.isSession) {
      // 获取澳洲当前时间与本地时间的时差
      const timeHour = sessionStorage.getItem('timeHour') || '2';
      var time = Date.parse(new Date(date));
      var newTime = moment(time + timeHour * 3600000).format(options.dateFormat || parseDateString(date));
      return newTime;
    } else {
      return moment(date).format(options.dateFormat || parseDateString(date));
    }
  } else {
    return date;
  }
}

function parseDateStringAll(input) {
  // 定义正则表达式来匹配不同的日期时间格式
  const regexFull = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/;
  const regexWithSeconds = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})$/;
  const regexWithMinutes = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2})$/;
  const regexDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/;

  // 尝试匹配不同的格式
  let match;
  if ((match = input.match(regexFull))) {
      // 年-月-日 时-分-秒
      return `DD/MM/YYYY HH:mm:ss`;
  } else if ((match = input.match(regexWithSeconds))) {
      // 年-月-日 时-分
      return `DD/MM/YYYY HH:mm`;
  } else if ((match = input.match(regexWithMinutes))) {
      // 年-月-日 时
      return `DD/MM/YYYY HH`;
  } else if ((match = input.match(regexDateOnly))) {
      // 年-月-日
      return `DD/MM/YYYY`;
  } else {
      // 格式不正确
      return false;
  }
}
export function quotationTimeFilter(date, options = {isSession:false, dateFormat:''}) {
  const regex = /^\d{4}-\d{2}-\d{2}/;
  if (date && !isNaN(new Date(date).getTime()) && regex.test(date)) {
    if(options.isSession){
      // 获取澳洲当前时间与本地时间的时差
      const timeHour = sessionStorage.getItem('timeHour') || '2';
      var time = Date.parse(new Date(date));
      var newTime = moment(time + timeHour * 3600000).format(options.dateFormat || parseDateString(date));
      return newTime;
    }else{
      return moment(date).format(options.dateFormat || parseDateStringAll(date));
    }
  } else {
    return date;
  }
}
